import { DrugIcd } from "@fusion-advantage/backcompat"
import { sqlQuery, sqlRun } from "./ldb"
import { bulkInsert } from "./bulkInsert"
import { CloudToDeviceOfflineTableDrugIcdBody } from "../redux/syncthunk/ZCloudToDevice"
import { err, ok, Result } from "neverthrow"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { selectAllText } from "./LdbBrowser"

// for info on distinction between Drug and Unfiltered ICD
// see comments in Icd.ts

export const selectAllDrugIcd = async (): Promise<Result<DrugIcd[], FusionError>> => {
	let r = await sqlQuery<DrugIcd>(`
		select Icd10Code, HistoryOf, Description, ComorbidityStatus
		  from drugIcd
		 order by Description
	`)
	if(r.isErr()) {
		return err(serializeFusionError('selectAllDrugIcd', r.error))
	}
	return ok(r.value)
}

export const selectAllDrugIcdText = async (): Promise<string> => {
	return selectAllText('drugIcd', ['Icd10Code', 'HistoryOf', 'Description', 'ComorbidityStatus'])
}

export const selectDrugIcdByProductId = async (productId: number): Promise<Result<DrugIcd[], FusionError>> => {
	let r = await sqlQuery<DrugIcd>(
		`
			select i.Icd10Code, i.HistoryOf, i.Description, i.ComorbidityStatus
			  from drugIcd i
			 inner join drugProductMap pm
			    on i.Icd10Code = pm.Icd10Code
			 where pm.ProductID = ?
			 order by i.Description
		`,
		[
			productId,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectDrugIcdByProductId', r.error))
	}
	return ok(r.value)
}

// 20250714 in use now by drug scanner v1 only...
interface DrugScannerV1Indication extends DrugIcd {
	IsManual: boolean
}

export const selectDs1ManualIndications = async (searchTerm?: string, category?: string): Promise<Result<DrugScannerV1Indication[], FusionError>> => {
	const where = searchTerm ? ' and Description like ?' : ''
	const params = searchTerm ? [searchTerm + '%'] : []
	// 20250714 with new feed, category no longer available
	// if (category) {
	// 	query += searchTerm ? ' AND' : ' WHERE'
	// 	query += ` Category = '${category}'`
	// }
	let r = await sqlQuery<DrugIcd>(
		`
			select Icd10Code, HistoryOf, Description, ComorbidityStatus
			  from drugIcd
			 where 1 = 1
			       ${where}
		`,
		params,
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectDs1ManualIndications', r.error))
	}
	return ok(r.value.map(code => ({...code, IsManual: true})))
}

export const selectDs1IcdByProductId = async (productId: number): Promise<Result<DrugScannerV1Indication[], FusionError>> => {
	let r = await selectDrugIcdByProductId(productId)
	if(r.isErr()) {
		return err(serializeFusionError('selectDs1IcdByProductId', r.error))
	}
	return ok(r.value.map(code => ({...code, IsManual: false})))
}

export const ldbDrugIcdBulkInsert = async (body: CloudToDeviceOfflineTableDrugIcdBody): Promise<Result<void, FusionError>> => {
	let r = await sqlRun('DELETE FROM drugIcd')
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugIcdBulkInsert', r.error))
	}
	let params = []
	for (let m of body.Codes) {
		params.push(m.Icd10Code, m.Description, m.HistoryOf, m.ComorbidityStatus)
	}
	r = await bulkInsert('drugIcd', params, 4)
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugIcdBulkInsert', r.error))
	}
	return ok()
}
